export default __webpack_public_path__ + "static/media/duo-chatting-black.286ae00d.svg";